(function($) {
    $(() => {
        $('.navbar-toggler').on('click', function() {
            $(this).toggleClass('is-active');
            $('.js-mobile-menu').toggleClass('open');
            $('body').toggleClass('mobile-menu-opened');
        });
    });
})(jQuery);
